import SparePartsSection from './SparePartsSection';

export default SparePartsSection;
